// extracted by mini-css-extract-plugin
export default {"sidebarTitle":"TaskFormSidebar_sidebarTitle__tJuZ1"};